export default "__VITE_ASSET__OQpBX6gz__"